<template>
  <el-dialog
    width="400px"
    class="save-popup-container"
    :visible="visible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div slot="title" class="popup-header">
      <img
        class="popup-close"
        src="@/assets/img/share-icon/ic-close.svg"
        alt=""
        @click="handleCancel"
      />
    </div>
    <div class="popup-content">
      <p class="popup-title">
        <img
          class="title-icon"
          src="@/assets/img/share-icon/location.svg"
          alt=""
        />
        {{ title }}
      </p>
      <p class="popup-text">{{ content }}</p>
    </div>
    <div slot="footer" class="popup-footer">
      <el-button class="cancel-btn default-btn" @click="handleCancel"
        >CANCEL</el-button
      >
      <el-button
        :loading="loading"
        class="save-btn default-btn"
        @click="handleSave"
        >CONFIRM</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleSave() {
      this.$emit("save");
    },
  },
};
</script>
<style lang="scss">
.save-popup-container {
  .el-dialog {
    margin: 0px !important;
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 350px;
    border-radius: 8px;
    background-color: #ffffff;
    .el-dialog__header {
      padding: 14px 14px 0;
      .popup-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 100%;
        .popup-close {
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      word-break: normal;
      .popup-content {
        padding: 0 24px;
        .popup-title {
          font-family: HelveticaNeue-Bold, sans-serif;
          font-size: 22px;
          text-align: left !important;
          color: #001b42;
          .title-icon {
            vertical-align: middle;
            margin-right: 3px;
          }
        }
        .popup-text {
          margin-top: 16px;
          font-family: HelveticaNeue, sans-serif;
          font-size: 16px;
          line-height: 1.38;
          text-align: center;
          color: #001b42;
        }
      }
    }
    .el-dialog__footer {
      padding: 32px 24px;
      .popup-footer {
        .default-btn {
          padding: 0;
          width: 91px !important;
          height: 36px;
          line-height: 36px;
          border: 0;
          text-align: center;
          border-radius: 4px;
          ::v-deep span {
            font-family: HelveticaNeue-Medium, sans-serif;
            font-size: 16px;
          }
        }
        .cancel-btn {
          background-color: #eceef1;
          color: #7f8da0;
        }
        .save-btn {
          background-color: #4066d4;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
